var _path, _path2, _path3, _path4;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgGoogle(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 128,
    height: 128,
    viewBox: "0 0 128 128",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M107.109 65.5014C107.109 62.5718 106.849 59.7906 106.404 57.0835H64.5V73.8081H88.4929C87.4175 79.2964 84.2654 83.9318 79.5929 87.0839V98.2089H93.9071C102.288 90.4585 107.109 79.0368 107.109 65.5014V65.5014Z",
    fill: "#4285F4"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M64.5 109C76.515 109 86.5646 104.995 93.9071 98.2089L79.5929 87.0839C75.5879 89.7539 70.5075 91.3855 64.5 91.3855C52.8929 91.3855 43.0658 83.5609 39.5429 72.9922H24.7838V84.4509C32.0892 98.9876 47.1079 109 64.5 109V109Z",
    fill: "#34A853"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M39.5429 72.992C38.6158 70.322 38.1337 67.4666 38.1337 64.4999C38.1337 61.5332 38.6529 58.6778 39.5429 56.0078V44.5491H24.7837C21.7429 50.5566 20 57.3057 20 64.4999C20 71.6941 21.7429 78.4432 24.7837 84.4507L39.5429 72.992Z",
    fill: "#FBBC05"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M64.5 37.6146C71.0638 37.6146 76.9229 39.8767 81.5583 44.2896L94.2408 31.6071C86.5646 24.4129 76.515 20 64.5 20C47.1079 20 32.0892 30.0125 24.7838 44.5492L39.5429 56.0079C43.0658 45.4392 52.8929 37.6146 64.5 37.6146V37.6146Z",
    fill: "#EA4335"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGoogle);
export default __webpack_public_path__ + "static/media/google.98e90cd321011be3f3471235e2472b7e.svg";
export { ForwardRef as ReactComponent };